import React from 'react';
import DataGrid, { Column, ColumnChooser, ColumnFixing } from 'devextreme-react/data-grid';
// import fullData from '../../data/table_organicSearch.json';
import numeral from 'numeral'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { SubAccount, ClientsAPI } from 'src/api'

type CellValue = number | string

type DataItem = {
  "page": string,
  "sessions": number,
  "sessions_change": CellValue,
  "newUsers": number,
  "newUsers_change": CellValue,
  "quality": number,
  "quality_change": CellValue,
  "conversion": number,
  "conversion_change": CellValue,
  "timeOnPage": number,
  "timeOnPage_change": CellValue,
  "pageViews": number,
  "pageViews_change": CellValue,
}

type Data = Array<DataItem>

type Cell = {
  data: DataItem,
  column: {
    dataField: string
  }
}

const IconUp = () => <FontAwesomeIcon icon={faCaretUp} color='green' />
const IconDown = () => <FontAwesomeIcon icon={faCaretDown} color='red' />

const ChangesCell = (cell: Cell) => {
  const { dataField } = cell.column
  const cellValue = cell.data[dataField]

  const actualTotoalField = dataField.replace('_change', '')
  const actualTotalValue = cell.data[actualTotoalField]

  if (typeof cellValue === 'string') {

    return (
      <div>
        <div style={{ fontSize: 20, fontWeight: 'bold' }}>{actualTotalValue}</div>
        <div style={{
          color: 'red',
          fontWeight: 'bold'
        }}
        >
          {'+'}{cellValue}{' '}
          {<IconUp />}
        </div>
      </div>
    )
  }
  const icon = cellValue > 0 ? <IconUp /> : cellValue === 0 ? null : <IconDown />

  return (
    <div>
      {cellValue === 0 ? '0' : (
        <>
          <div style={{ fontSize: 20, fontWeight: 'bold' }}>{actualTotalValue}</div>
          <div
            style={{
              color: cellValue > 0 ? 'green' : cellValue === 0 ? 'grey' : 'red',
              fontWeight: 'bold',
              fontSize: 14,

            }}
          >
            {numeral(cellValue).format('0%')} {icon}
          </div>
        </>
      )}
    </div>
  )
}

type TableProps = {
  client?: SubAccount
}
class TableOrganic extends React.Component<TableProps>{
  state = {
    data: undefined,
    narrative: undefined
  }
  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
      report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
      sub_account_id: client.id,
      period_index: "1449",
      period_type: "monthly"
    }

    ClientsAPI.getReportData(client, 'table_organicSearch.json').then(result => {
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    ClientsAPI.getNarrative(client, params).then(result => {
      // console.log('done', result)
      this.setState({ narrative: result[0] });
    }).catch(error => {
      // console.log('error', error)
    })
  }
  // parseData(data: Data) {
  //   return data
  // }

  render() {
    const { data, narrative } = this.state
    const { client } = this.props;
    // const { narrative } = this.state
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (
      <>
        <DataGrid
          dataSource={data}
          id="gridContainer"
          allowColumnReordering={true}
          allowColumnResizing={true}
          // columnAutoWidth={true}
          showBorders={true}

        >
          <ColumnChooser enabled={true} />
          <ColumnFixing enabled={true} />
          <Column dataField="path" minWidth={330} />


          <Column
            dataField='sessions_change'
            caption="Sessions"
            cellRender={ChangesCell}
            width={140}
          />

          <Column
            dataField='newUsers_change'
            caption="New Users"
            cellRender={ChangesCell}
            width={140}

          />

          <Column
            dataField='quality_change'
            caption="Quality Sessions"
            cellRender={ChangesCell}
            width={140}

          />


          <Column
            dataField='timeOnPage_change'
            caption="Time On Page"
            cellRender={ChangesCell}
            width={140}

          />

          <Column
            dataField='pageViews_change'
            caption="Page Views"
            cellRender={ChangesCell}
            width={140}

          />

          <Column
            dataField='conversion_change'
            caption="Conversions"
            cellRender={ChangesCell}
            width={140}

          />
        </DataGrid>

        {JSON.stringify(narrative, null, 2)}
      </>
    );
  }
}

export default TableOrganic;



// WEBPACK FOOTER //
// ./src/components/ReportComponents/TableOrganic.tsx